import styled from 'styled-components'
import { Button, Steps } from 'antd'

export const FormalityColorSuccess = '#55d381'
export const FormalityColorWarning = '#f69d3c'
export const FormalityColorError = '#ff4d4f'

export const FormalityBox = styled.div`
  background-color: white;
  border-radius: 10px;
  padding: 20px 20px;
  margin-bottom: 16px;
`

export const FormalityResumeWrapper = styled.div`
  margin-left: 0 !important;
  margin-right: 0 !important;
  min-width: 100px;
  display: flex;
  flex-flow: column nowrap;
  justify-content: space-between;

  li {
    display: flex;
    flex-flow: row nowrap;
  }
`
export const ResumeLabel = styled.span`
  font-weight: bold;
`
export const ResumeValue = styled.span`
  flex-grow: 1;
  text-align: right;
  padding-left: 10px;
`

export const PopoverBody = styled.div`
  display: flex;
  flex-flow: column nowrap;
`
export const StepTitleWrapper = styled.div`
  display: flex;
  flex-flow: column;
  gap: 18px;
  align-content: center;
  justify-content: flex-end;
  font-size: 13px;
`
export const StepTitle = styled.div``
export const StepDate = styled.div`
  opacity: 0.7;
`

export const ProgressTitleWrapper = styled.div`
  display: flex;
  flex-flow: row nowrap;
  justify-content: space-between;
`

export const ProgressBarWrapper = styled.div`
  flex-grow: 1;
  display: flex;
  flex-flow: column nowrap;
  gap: 10px;
  h4 {
    margin: 0;
    font-size: 15px;
    font-weight: 600;
    padding-left: 35px;
  }
`

export const ProgressBar = styled(Steps)`
  padding: 43px 88px 24px 0;

  && {
    .ant-steps-item-icon {
      z-index: 100;
      position: relative;

      .ant-steps-icon-dot {
        background: white !important;
        border: 4px solid rgba(5, 5, 5, 0.06);
        padding: 4px;
        position: absolute;
        top: -4px;
        left: -7px;
      }
    }
    .ant-steps-item-content {
      margin-top: 0;
      position: absolute;
      bottom: -25px;
      z-index: 13;
      display: flex;
      flex-flow: column nowrap;

      .ant-steps-item-title {
        position: absolute;
        bottom: 0;
        left: 0;
        width: 100%;

        .ant-steps-item-description {
          display: none !important;
        }
      }
    }

    .ant-steps-item-wait,
    .ant-steps-item-process {
      ${StepDate} {
        opacity: 0;
      }
    }
    .ant-steps-item-process {
      .ant-steps-icon-dot {
        inset-inline-start: -9px !important;
        border-color: ${FormalityColorWarning};
      }
    }
    .ant-steps-item-finish {
      &.ant-steps-item-active {
        .ant-steps-item-tail {
          &::after {
            background: linear-gradient(
              0.25turn,
              ${FormalityColorSuccess},
              #ebf8e1,
              ${FormalityColorWarning}
            );
          }
        }
      }
      .ant-steps-item-tail {
        &::after {
          background-color: ${FormalityColorSuccess};
        }
      }
      .ant-steps-icon-dot {
        border: 4px solid ${FormalityColorSuccess};
        left: -8px;
      }
    }
    .ant-steps-item-error {
      font-weight: bold;
      .ant-steps-icon-dot {
        border: 4px solid ${FormalityColorError};
      }
    }
  }
  &&.aborted {
    .ant-steps-item-finish,
    .ant-steps-item-error {
      .ant-steps-item-tail {
        &::after {
          background: none;
          background-color: ${FormalityColorError} !important;
        }
      }
      .ant-steps-icon-dot {
        border: 4px solid ${FormalityColorError};
        left: -8px;
      }
    }
  }
  &&.finished {
    .ant-steps-item-finish {
      .ant-steps-item-tail {
        &::after {
          background: none;
          background-color: ${FormalityColorSuccess} !important;
        }
      }
      .ant-steps-icon-dot {
        border: 4px solid ${FormalityColorSuccess};
        left: -8px;
      }
    }
  }
`

export const FormalityHeader = styled.div`
  width: 100%;
  display: flex;
  flex-flow: row nowrap;
`

export const FormalityFormulaire = styled.div`
  h3 {
    font-size: 28px;
    font-weight: bold;
    color: #55d381;
  }
`

// DOCUMENTS

export const DocumentTypesListWrapper = styled.div`
  display: flex;
  flex-flow: wrap;
  gap: 10px 5px;
`

export const Tag = styled(Button)`
  margin-right: 4px;
  font-weight: bold;
  color: #6682af;
  background-color: #ebeef3;
  font-size: 13px;
  box-shadow: 0 4px 2px -2px gray;
`

export const ChecksWrapper = styled.div`
  display: flex;
  flex-direction: column;
`

export const Check = styled.div`
  display: flex;
  margin: 0 0 15px 0;
  min-width: 66px;
  flex-shrink: 0;
`

export const Instructions = styled.span`
  margin-left: 15px;
`

export const FormalityAbortWrapper = styled.div`
  padding: 200px 0 20px 0;
  display: flex;
  justify-content: end;
  gap: 10px;
`

export const FormalityActionsWrapper = styled.div`
  margin: 15px 0;
  display: flex;
  justify-content: flex-end;
  gap: 10px;
`
